import useAsyncData from "../../../../hooks/use-async-data";
import orderService from "../../order.service";
import OrderCargoOrderActiveList from "./order-cargo-order-active-list";
import OrderCargoOrderActiveListParams from "./order-cargo-order-active-list-params";

const useOrderCargoOrderActiveList = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<OrderCargoOrderActiveList>({
      data: [],
    });

  const load = async (
    params: OrderCargoOrderActiveListParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoOrderActiveList = await orderService.getActiveList(
        params,
        signal,
      );

      setData(cargoOrderActiveList);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useOrderCargoOrderActiveList;
